import { useRef, useEffect, useState } from "react";
import TradeAccount from "../assets/GTA-V2-min.webp";
import { HiBadgeCheck } from "react-icons/hi";

export default function GlobalTradePoints() {
  const imageRef = useRef<HTMLImageElement>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setInView(entry.isIntersecting),
      { threshold: 0.3 }
    );
    if (imageRef.current) observer.observe(imageRef.current);
    return () => {
      if (imageRef.current) observer.unobserve(imageRef.current);
    };
  }, []);

  const points = [
    "50% better FX margins compared to banks",
    "See real-time FX rates and book instantly",
    "Manage orders and payments in one place",
    "Receive SWIFT receipts within 24 hours",
    "Knock off Shipping Bills and BOEs",
    "Generate Bank Realisation Certificates",
  ];

  return (
    <section className="flex flex-col md:flex-row items-center justify-between px-4 md:px-8 lg:px-[15%] mt-[140px] py-12 gap-8 text-gray-900">
      {/* Text Block */}
      <div className="w-full md:w-1/2 text-center md:text-left px-0 md:px-4">
        <h2 className="font-bold text-2xl sm:text-3xl md:text-4xl lg:text-5xl leading-tight">
          Global Trade Account​
        </h2>
        <p className="text-lg md:text-2xl mt-4 md:mt-6 text-gray-600">
          Open a current account with our partner banks to send and receive trade payments.
        </p>
        <ul className="mt-6 space-y-4 text-left text-lg text-gray-600">
          {points.map((text, idx) => (
            <li key={idx} className="flex items-start">
              <HiBadgeCheck className="text-[#27a887] mr-3 mt-1 flex-shrink-0" />
              <span>{text}</span>
            </li>
          ))}
        </ul>
      </div>

      {/* Image Block */}
      <div className="w-full md:w-1/2 flex justify-center px-0 md:px-4 mt-10 md:mt-0">
        <img
          ref={imageRef}
          src={TradeAccount}
          alt="Global Trade Account illustration"
          className={`
            w-full
            max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg
            transition-transform duration-700 ease-in-out
            ${inView ? "scale-110" : "scale-95"}
          `}
        />
      </div>
    </section>
  );
}
